import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";

/**
 * Vytvori logout pipe.
 *
 * @param {*} setAccessToken
 * @param {*} getLogoutHandlers
 * @param {*} handleParentLogout
 * @param {*} setContext
 *
 * @returns {Function} `() => Promise<any>`
 */
export default function createLogoutPipe(setStoredAuthData, getLogoutHandlers, handleParentLogout, setContext) {
  function logout() {
    return _logout.apply(this, arguments);
  }

  function _logout() {
    _logout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", new Promise(function (resolve, reject) {
                setContext({});
                setStoredAuthData(null);
                return Promise.all(getLogoutHandlers().map(function (f) {
                  return f();
                })).then(function () {
                  return handleParentLogout ? handleParentLogout() : null;
                }).then(function () {
                  return resolve();
                }).catch(function (error) {
                  return reject(error);
                });
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _logout.apply(this, arguments);
  }

  return logout;
}